import ClientImg1 from "../assets/images/client/1.svg";
import ClientImg2 from "../assets/images/client/2.svg";
import ClientImg3 from "../assets/images/client/3.svg";
import ClientImg4 from "../assets/images/client/4.svg";
import ClientImg5 from "../assets/images/client/5.svg";
import ClientImg6 from "../assets/images/client/6.svg";
import ClientImg7 from "../assets/images/client/7.svg";
import ClientImg8 from "../assets/images/client/8.svg";
import ClientImg9 from "../assets/images/client/9.svg";
import ClientImg10 from "../assets/images/client/10.svg";
import ClientImg11 from "../assets/images/client/11.svg";
import ClientImg12 from "../assets/images/client/12.svg";
import ClientImg13 from "../assets/images/client/13.svg";
import ClientImg14 from "../assets/images/client/14.svg";
import ClientImg15 from "../assets/images/client/15.svg";
import ClientImg16 from "../assets/images/client/16.svg";
import ClientImg17 from "../assets/images/client/17.svg";
import ClientImg18 from "../assets/images/client/18.svg";

export const clients: string[] = [
  ClientImg1,
  ClientImg2,
  ClientImg3,
  ClientImg4,
  ClientImg5,
  ClientImg6,
  ClientImg7,
  ClientImg8,
  ClientImg9,
  ClientImg10,
  ClientImg11,
  ClientImg12,
  ClientImg13,
  ClientImg14,
  ClientImg15,
  ClientImg16,
  ClientImg17,
  ClientImg18,
];
